import { LoadingButton, LoadingButtonProps } from '../button/loading-button';
import { PaywallModalWrapper } from './paywall-modal-wrapper';
import { PaywallComponentBaseProps } from './paywall.types';

export interface PaywallLoadingButtonProps extends PaywallComponentBaseProps {
  loadingButtonProps: LoadingButtonProps;
}

const PaywallLoadingButton = (props: PaywallLoadingButtonProps) => {
  const {
    planEntitlementKey,
    isFeatureAvailable,
    loadingButtonProps,
    children,
  } = props;

  return (
    <PaywallModalWrapper planEntitlementKey={planEntitlementKey}>
      {({ presentUpgrade, hasEntitlement }) => {
        const isAvailable = isFeatureAvailable
          ? isFeatureAvailable(hasEntitlement)
          : hasEntitlement;

        return (
          <LoadingButton
            {...loadingButtonProps}
            buttonProps={{
              ...loadingButtonProps.buttonProps,
              onClick: (e) => {
                if (isAvailable) {
                  if (
                    typeof loadingButtonProps?.buttonProps?.onClick ===
                    'function'
                  ) {
                    loadingButtonProps?.buttonProps?.onClick(e);
                  }
                } else {
                  e.stopPropagation();
                  e.preventDefault();
                  presentUpgrade();
                }
              },
            }}
          >
            {children}
          </LoadingButton>
        );
      }}
    </PaywallModalWrapper>
  );
};

export { PaywallLoadingButton };
